import { transformBundleOptions } from '../bundleOptions/index.js';
import { transformConfigurableOptions } from '../configurableOptions/index.js';
import { transformCustomOptions } from '../customOptions/index.js';
import { transformGiftCardOptions } from '../giftcardOptions/index.js';
import { transformGroupedOptions } from '../groupedOptions/index.js';
import { transformCatalogProductResponse, transformProductOptions } from '../product/index.js';
import { transformTotals } from '../cartCheckout/index.js';

const transformOrderTotals = ({ currency , discount_amount , discount_description , coupon_code , grand_total , price , shipping_amount , subtotal , subtotal_incl_tax , tax_amount , giftcard_amount , cod_fee_amount  })=>({
        currency,
        discountAmount: discount_amount,
        discountDescription: discount_description,
        couponCode: coupon_code,
        grandTotal: grand_total,
        price,
        shippingAmount: shipping_amount,
        subtotal,
        subtotalInclTax: subtotal_incl_tax,
        taxAmount: tax_amount,
        giftCards: giftcard_amount ? -giftcard_amount : null,
        cashOnDelivery: cod_fee_amount ?? null
    });
const transformOrder = ({ id , increment_id , amount , tax_amount , coupon , subtotal , gw_total , msp_cod , gift_option_final_price , reward_points_balance , reward_points_amount , items , shipping , totals: { gift_cards_amount , gift_cards , ...totals } = {} , totals: allTotals = null , livstick_video  })=>({
        id,
        number: increment_id,
        coupon: coupon ?? null,
        totals: !allTotals || Array.isArray(allTotals) // if totals are not present or it is an array of keys, keep old logic
         ? {
            grandTotal: amount,
            tax: tax_amount,
            shipping,
            subtotal,
            cashOnDelivery: msp_cod ?? null,
            giftWrap: gw_total ?? null,
            rewardPointsBalance: reward_points_balance ?? null,
            rewardPointsCurrency: reward_points_amount ?? null
        } : {
            ...transformTotals({
                ...totals,
                ...{
                    grand_total: amount,
                    msp_cod,
                    gift_option_final_price,
                    reward_points_balance,
                    reward_currency_amount: reward_points_amount,
                    gift_cards: gift_cards_amount ? -gift_cards_amount : undefined,
                    gift_cards_informations: gift_cards && typeof gift_cards === 'string' ? JSON.parse(gift_cards) : gift_cards
                }
            })
        },
        items: items.map(({ id , sku , name , price , quantity , parent_sku , product_data , metadata , product_options  })=>{
            const productData = transformCatalogProductResponse(product_data);
            const qty = parseFloat(quantity);
            const transformedMetadata = {
                configurableOptions: transformConfigurableOptions(metadata?.configurable_options, product_data?.variants),
                customOptions: transformCustomOptions(metadata?.custom_options),
                bundleOptions: transformBundleOptions(metadata?.bundle_options),
                groupedOptions: transformGroupedOptions(metadata?.grouped_options),
                giftcardOptions: transformGiftCardOptions(metadata?.giftcard_item_option, productData)
            };
            return {
                id: id ?? null,
                sku,
                parentSku: parent_sku,
                name,
                metadata: transformedMetadata,
                productType: product_data?.type ?? null,
                productData: {
                    ...productData,
                    inventory: {
                        ...productData.inventory,
                        // force inventory to be in stock for order summary success page
                        inStock: true,
                        saleable: true
                    }
                },
                productOptions: transformProductOptions(product_options, productData, transformedMetadata),
                qty,
                totals: {
                    price: price,
                    subtotal: price * qty
                }
            };
        }),
        ...livstick_video ? {
            livStickVideo: livstick_video
        } : {}
    });

export { transformOrder, transformOrderTotals };
